// src/pages/SpecialSolutions.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import SpecialSolutions_PageContent from './PageComponent/SpecialSolutions_PageContent';

function SpecialSolutions() {
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Special Solutions for Challenging Architectural Designed Windows</title>
                <meta
                    name="description"
                    content="Callistus Blinds provides solutions for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/special-solutions/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Special Solutions" />
                <meta
                    property="og:description"
                    content="Callistus Blinds provides solutions for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/special-solutions/`} />
                <meta property="og:site_name" content="Callistus Blinds" />
            </Helmet>

            <div>
                <Navbar />
                <NotificationBar />
                <SpecialSolutions_PageContent />
                <Footer />
            </div>
        </>
    );
}

export default SpecialSolutions;